import type { EditorLoadPayload } from '../types';

/**
 * Mock fonts available in the editor
 */
export const MOCK_FONTS = [
  { id: '1', name: 'Arial' },
  { id: '2', name: 'Arial Black' },
  { id: '3', name: 'Times New Roman' },
  { id: '4', name: 'Courier New' },
  { id: '5', name: 'Georgia' },
  { id: '6', name: 'Verdana' },
  { id: '7', name: 'Tahoma' },
  { id: '8', name: 'Trebuchet MS' },
  { id: '9', name: 'Impact' },
  { id: '10', name: 'Comic Sans MS' },
];

/**
 * Mock media items (backgrounds, pictures)
 */
export const MOCK_MEDIA = [
  { id: 'bg-1', name: 'Blue Gradient', mediaType: 'Background' },
  { id: 'bg-2', name: 'Dark Background', mediaType: 'Background' },
  { id: 'bg-3', name: 'Light Gray', mediaType: 'Background' },
  { id: 'pic-1', name: 'Logo', mediaType: 'Picture' },
  { id: 'pic-2', name: 'Banner Image', mediaType: 'Picture' },
];

/**
 * Mock template with sample blocks for development
 */
export const MOCK_TEMPLATE_PAYLOAD: EditorLoadPayload = {
  layoutType: 'bulletin',
  template: {
    id: 'demo-template-001',
    name: 'Demo Template',
    description: 'A sample template for development testing',
    backgroundID: '',
    isNew: false,
    isDynamic: false,
    blocks: [
      {
        Name: 'Title',
        BlockType: 'Text',
        X: 100,
        Y: 80,
        Width: 1720,
        Height: 120,
        Text: 'Welcome to CablecastCG',
        TextFont: 'Arial Black',
        TextSize: 72,
        TextBold: true,
        TextItalic: false,
        TextStrikeout: false,
        TextUnderline: false,
        TextColor: 'FFFFFF',
        TextColorOpacity: 255,
        TextHorizAlignment: 'Center',
        TextVertAlignment: 'Center',
        TextWrap: false,
        AutoSizeText: true,
        TextMaxLength: -1,
        TextGradient: false,
        TextGradientColor: '000000',
        TextGradientMode: 'Horizontal',
        TextGradientOpacity: 255,
        TextOutline: false,
        TextOutlineColor: '000000',
        TextOutlineOpacity: 255,
        TextShadow: true,
        TextShadowColor: '000000',
        TextShadowDepth: 3,
        TextShadowOpacity: 180,
        TextGlow: false,
        TextGlowColor: 'FFFFFF',
        RotateDegrees: 0,
        RectColor: '2cb466',
        RectColorOpacity: 255,
        RectGradient: false,
        RectGradientColor: '000000',
        RectGradientMode: 'Horizontal',
        RectGradientOpacity: 255,
        RectOutline: false,
        RectOutlineColor: '000000',
        RectOutlineWidth: 1,
        RectOutlineOpacity: 255,
        RectShadow: false,
        RectShadowColor: '000000',
        RectShadowDepth: 5,
        RectShadowOpacity: 128,
        Reflection: false,
        ReflectionOpacity: 128,
        ReflectionOffset: 0,
        ReflectionHeight: 50,
      },
      {
        Name: 'Subtitle',
        BlockType: 'Text',
        X: 100,
        Y: 220,
        Width: 1720,
        Height: 60,
        Text: 'Modern Template Editor',
        TextFont: 'Arial',
        TextSize: 36,
        TextBold: false,
        TextItalic: true,
        TextStrikeout: false,
        TextUnderline: false,
        TextColor: 'E0E0E0',
        TextColorOpacity: 255,
        TextHorizAlignment: 'Center',
        TextVertAlignment: 'Center',
        TextWrap: false,
        AutoSizeText: true,
        TextMaxLength: -1,
        TextGradient: false,
        TextGradientColor: '000000',
        TextGradientMode: 'Horizontal',
        TextGradientOpacity: 255,
        TextOutline: false,
        TextOutlineColor: '000000',
        TextOutlineOpacity: 255,
        TextShadow: false,
        TextShadowColor: '000000',
        TextShadowDepth: 2,
        TextShadowOpacity: 128,
        TextGlow: false,
        TextGlowColor: 'FFFFFF',
        RotateDegrees: 0,
        RectColor: 'FFFFFF',
        RectColorOpacity: 0,
        RectGradient: false,
        RectGradientColor: '000000',
        RectGradientMode: 'Horizontal',
        RectGradientOpacity: 255,
        RectOutline: false,
        RectOutlineColor: '000000',
        RectOutlineWidth: 1,
        RectOutlineOpacity: 255,
        RectShadow: false,
        RectShadowColor: '000000',
        RectShadowDepth: 5,
        RectShadowOpacity: 128,
        Reflection: false,
        ReflectionOpacity: 128,
        ReflectionOffset: 0,
        ReflectionHeight: 50,
      },
      {
        Name: 'InfoBox',
        BlockType: 'Rectangle',
        X: 100,
        Y: 350,
        Width: 800,
        Height: 400,
        Text: '',
        RotateDegrees: 0,
        RectColor: '4b4b5e',
        RectColorOpacity: 200,
        RectGradient: false,
        RectGradientColor: '2cb466',
        RectGradientMode: 'Vertical',
        RectGradientOpacity: 255,
        RectOutline: true,
        RectOutlineColor: '2cb466',
        RectOutlineWidth: 3,
        RectOutlineOpacity: 255,
        RectShadow: true,
        RectShadowColor: '000000',
        RectShadowDepth: 10,
        RectShadowOpacity: 100,
        Reflection: false,
        ReflectionOpacity: 128,
        ReflectionOffset: 0,
        ReflectionHeight: 50,
      },
      {
        Name: 'InfoText',
        BlockType: 'Text',
        X: 130,
        Y: 380,
        Width: 740,
        Height: 340,
        Text: 'This is a demo of the new React-based template editor. It features:\n\n• Modern, accessible UI\n• Responsive design\n• Real-time preview\n• Keyboard navigation',
        TextFont: 'Arial',
        TextSize: 24,
        TextBold: false,
        TextItalic: false,
        TextStrikeout: false,
        TextUnderline: false,
        TextColor: 'FFFFFF',
        TextColorOpacity: 255,
        TextHorizAlignment: 'Near',
        TextVertAlignment: 'Near',
        TextWrap: true,
        AutoSizeText: false,
        TextMaxLength: -1,
        TextGradient: false,
        TextGradientColor: '000000',
        TextGradientMode: 'Horizontal',
        TextGradientOpacity: 255,
        TextOutline: false,
        TextOutlineColor: '000000',
        TextOutlineOpacity: 255,
        TextShadow: false,
        TextShadowColor: '000000',
        TextShadowDepth: 2,
        TextShadowOpacity: 128,
        TextGlow: false,
        TextGlowColor: 'FFFFFF',
        RotateDegrees: 0,
        RectColor: 'FFFFFF',
        RectColorOpacity: 0,
        RectGradient: false,
        RectGradientColor: '000000',
        RectGradientMode: 'Horizontal',
        RectGradientOpacity: 255,
        RectOutline: false,
        RectOutlineColor: '000000',
        RectOutlineWidth: 1,
        RectOutlineOpacity: 255,
        RectShadow: false,
        RectShadowColor: '000000',
        RectShadowDepth: 5,
        RectShadowOpacity: 128,
        Reflection: false,
        ReflectionOpacity: 128,
        ReflectionOffset: 0,
        ReflectionHeight: 50,
      },
      {
        Name: 'StatusBox',
        BlockType: 'Rectangle',
        X: 980,
        Y: 350,
        Width: 840,
        Height: 400,
        Text: '',
        RotateDegrees: 0,
        RectColor: '2cb466',
        RectColorOpacity: 255,
        RectGradient: true,
        RectGradientColor: '1a8a4f',
        RectGradientMode: 'Vertical',
        RectGradientOpacity: 255,
        RectOutline: false,
        RectOutlineColor: '000000',
        RectOutlineWidth: 1,
        RectOutlineOpacity: 255,
        RectShadow: true,
        RectShadowColor: '000000',
        RectShadowDepth: 10,
        RectShadowOpacity: 100,
        Reflection: false,
        ReflectionOpacity: 128,
        ReflectionOffset: 0,
        ReflectionHeight: 50,
      },
      {
        Name: 'StatusText',
        BlockType: 'Text',
        X: 1010,
        Y: 380,
        Width: 780,
        Height: 340,
        Text: 'Phase 1: Foundation\n\n✓ React + TypeScript\n✓ Zustand Store\n✓ Canvas Component\n✓ Block Rendering\n✓ Theme System',
        TextFont: 'Arial',
        TextSize: 24,
        TextBold: false,
        TextItalic: false,
        TextStrikeout: false,
        TextUnderline: false,
        TextColor: 'FFFFFF',
        TextColorOpacity: 255,
        TextHorizAlignment: 'Near',
        TextVertAlignment: 'Near',
        TextWrap: true,
        AutoSizeText: false,
        TextMaxLength: -1,
        TextGradient: false,
        TextGradientColor: '000000',
        TextGradientMode: 'Horizontal',
        TextGradientOpacity: 255,
        TextOutline: false,
        TextOutlineColor: '000000',
        TextOutlineOpacity: 255,
        TextShadow: false,
        TextShadowColor: '000000',
        TextShadowDepth: 2,
        TextShadowOpacity: 128,
        TextGlow: false,
        TextGlowColor: 'FFFFFF',
        RotateDegrees: 0,
        RectColor: 'FFFFFF',
        RectColorOpacity: 0,
        RectGradient: false,
        RectGradientColor: '000000',
        RectGradientMode: 'Horizontal',
        RectGradientOpacity: 255,
        RectOutline: false,
        RectOutlineColor: '000000',
        RectOutlineWidth: 1,
        RectOutlineOpacity: 255,
        RectShadow: false,
        RectShadowColor: '000000',
        RectShadowDepth: 5,
        RectShadowOpacity: 128,
        Reflection: false,
        ReflectionOpacity: 128,
        ReflectionOffset: 0,
        ReflectionHeight: 50,
      },
      {
        Name: 'Footer',
        BlockType: 'Text',
        X: 100,
        Y: 800,
        Width: 1720,
        Height: 50,
        Text: 'CablecastCG • Template Editor Demo',
        TextFont: 'Arial',
        TextSize: 20,
        TextBold: false,
        TextItalic: false,
        TextStrikeout: false,
        TextUnderline: false,
        TextColor: '9f9fa5',
        TextColorOpacity: 255,
        TextHorizAlignment: 'Center',
        TextVertAlignment: 'Center',
        TextWrap: false,
        AutoSizeText: true,
        TextMaxLength: -1,
        TextGradient: false,
        TextGradientColor: '000000',
        TextGradientMode: 'Horizontal',
        TextGradientOpacity: 255,
        TextOutline: false,
        TextOutlineColor: '000000',
        TextOutlineOpacity: 255,
        TextShadow: false,
        TextShadowColor: '000000',
        TextShadowDepth: 2,
        TextShadowOpacity: 128,
        TextGlow: false,
        TextGlowColor: 'FFFFFF',
        RotateDegrees: 0,
        RectColor: 'FFFFFF',
        RectColorOpacity: 0,
        RectGradient: false,
        RectGradientColor: '000000',
        RectGradientMode: 'Horizontal',
        RectGradientOpacity: 255,
        RectOutline: false,
        RectOutlineColor: '000000',
        RectOutlineWidth: 1,
        RectOutlineOpacity: 255,
        RectShadow: false,
        RectShadowColor: '000000',
        RectShadowDepth: 5,
        RectShadowOpacity: 128,
        Reflection: false,
        ReflectionOpacity: 128,
        ReflectionOffset: 0,
        ReflectionHeight: 50,
      },
    ],
  },
  zone: {
    id: 'zone-1',
    name: 'Default Zone',
    graphicsWidth: 1920,
    graphicsHeight: 1080,
  },
  media: MOCK_MEDIA,
  fonts: MOCK_FONTS,
};

/**
 * Empty template for testing
 */
export const EMPTY_TEMPLATE_PAYLOAD: EditorLoadPayload = {
  layoutType: 'bulletin',
  template: {
    id: 'empty-template',
    name: 'New Template',
    description: '',
    backgroundID: '',
    isNew: true,
    isDynamic: false,
    blocks: [],
  },
  zone: {
    id: 'zone-1',
    name: 'Default Zone',
    graphicsWidth: 1920,
    graphicsHeight: 1080,
  },
  media: MOCK_MEDIA,
  fonts: MOCK_FONTS,
};
